<template>
  <v-dialog v-model="dialog" :max-width="500" @keydown.esc="cancel" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary" dense flat>
        <v-toolbar-title class="white--text">File Upload</v-toolbar-title>

        <v-spacer/>

        <v-btn icon color="white" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <vx-file-upload ref="fileUpload" flat/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FileUpload from '../files/FileUpload.vue'

export default {
  name: 'UploadDialog',
  components: {
    'vx-file-upload': FileUpload
  },
  props: {
    value: Boolean
  },
  data: () => ({
  }),
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.$refs.fileUpload.clearForm()
    }
  }
}
</script>
